var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26684(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26684",
    "data-name": "Group 26684",
    transform: "translate(-56 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(56 788)",
    fill: "#1859bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23246",
    "data-name": "Path 23246",
    d: "M153.1,80.986a11.724,11.724,0,0,1-11.725,11.659h-7.035V99.68a2.345,2.345,0,1,1-4.69,0V71.541a2.344,2.344,0,0,1,2.345-2.345h9.38A11.838,11.838,0,0,1,153.1,80.986m-4.69-.066a7.042,7.042,0,0,0-7.035-7.035h-7.035V87.955h7.035a7.043,7.043,0,0,0,7.035-7.034",
    transform: "translate(-47.646 738.804)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26684);
export default __webpack_public_path__ + "static/media/Group 26684.85f06f63cebb230384c21b20d6987108.svg";
export { ForwardRef as ReactComponent };